import { AgGridReact } from "ag-grid-react";
import { useState, useEffect } from 'react';
import { FormatUSD } from "Components/CustomComponents/ValueFormatters/GridValueFormatters";

export default function CustomerLeftoverOAPGrid({
    pieCustomer,
    leftoverOapsArray
}) {
    const [gridApi, setGridApi] = useState();
    const [leftoverOapColDefs, setLeftoverOapColDefs] = useState();
    const [leftoverOapRowData, setLeftoverOapRowData] = useState();
    const [defaultColDef] = useState({
        sortable: true,
        resizable: true,
        filter: true,
    });

    useEffect(() => {
        if (pieCustomer) {
            let oapsArray = leftoverOapsArray.filter(customer => customer.CustomerName === pieCustomer);
            setLeftoverOapRowData(oapsArray);
        }
        // eslint-disable-next-line
    }, [pieCustomer]);

    useEffect(() => {
        if (leftoverOapRowData) {
            setLeftoverOapColDefs([
                {
                    field: "CustomerName",
                    editable: true,
                    valueParser: params => params.newValue
                },
                {
                    field: "OAPAmount",
                    sort: 'desc',
                    valueFormatter: (data) => FormatUSD(data)
                },
                {
                    field: "OAPNumber",
                }
            ]);
        }
        // eslint-disable-next-line
    }, [pieCustomer, leftoverOapRowData]);

    const onFirstDataRendered = (params) => { 
        setGridApi(params.api);
        params.columnApi.autoSizeAllColumns();
    };
    
    return (
        <>
            <h6>Leftover OAPs By Customer</h6>
            <div className="ag-theme-alpine">
                <AgGridReact
                    rowData={leftoverOapRowData}
                    columnDefs={leftoverOapColDefs}
                    defaultColDef={defaultColDef}
                    onFirstDataRendered={onFirstDataRendered}
                    gridApi={gridApi}
                />
            </div>
        </>
    );
}